import type { NoteEditorFlushReason } from "notion-style-editor";

export interface KnowledgeRouteLeaveHandle {
  readonly hasPendingChanges: () => boolean;
  readonly flush: (reason: NoteEditorFlushReason) => Promise<void>;
}

/**
 * Keeps platform lifecycle handling independent from a concrete editor.
 * Only the currently mounted route owns the registration, and stale cleanup
 * functions cannot accidentally unregister a newer editor.
 */
export class KnowledgeRouteLeaveRegistry {
  private readonly active = new Set<KnowledgeRouteLeaveHandle>();

  register(handle: KnowledgeRouteLeaveHandle): () => void {
    this.active.add(handle);
    return () => {
      this.active.delete(handle);
    };
  }

  hasPendingChanges(): boolean {
    return [...this.active].some((handle) => handle.hasPendingChanges());
  }

  async flush(reason: NoteEditorFlushReason): Promise<void> {
    await Promise.all([...this.active].map((handle) => handle.flush(reason)));
  }
}
